'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mediaButton = require('../../../atoms/media-button');

var _mediaButton2 = _interopRequireDefault(_mediaButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoImage = function (_React$Component) {
  _inherits(VideoImage, _React$Component);

  function VideoImage(props) {
    _classCallCheck(this, VideoImage);

    var _this = _possibleConstructorReturn(this, (VideoImage.__proto__ || Object.getPrototypeOf(VideoImage)).call(this, props));

    _this.calculateHeight = function () {
      var width = _this.state.width;

      if (_this.videoImage) {
        width = _this.videoImage.clientWidth || _this.videoImage.offsetWidth;
      }
      if (width && width !== _this.state.width) {
        _this.setState({
          width: width
        });
      }
    };

    _this.state = {
      width: 250
    };
    return _this;
  }

  _createClass(VideoImage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.calculateHeight);
      this.calculateHeight();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.calculateHeight();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.calculateHeight);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var mediaButton = this.props.content.mediaButton;
      var backgroundImage = this.props.config.backgroundImage;

      var moleculeClasses = (0, _classnames2.default)('video-image', this.props.className, {
        'video-image--no-text': !mediaButton.text
      });

      var mediaButtonText = mediaButton.text ? '-' + mediaButton.text : '';
      var mediaBtnIdx = this.props.idx !== undefined ? this.props.idx : null;

      // Formula is for the ratio 16:9
      return _react2.default.createElement(
        'div',
        {
          className: moleculeClasses,
          ref: function ref(el) {
            _this2.videoImage = el;
          },
          style: {
            backgroundImage: 'url(' + backgroundImage.url + ')',
            height: Math.round(this.state.width / 16 * 9)
          }
        },
        _react2.default.createElement(
          _mediaButton2.default,
          {
            id: mediaButton.id,
            className: 'video-image__media-btn',
            fpti: '' + this.props.name + mediaBtnIdx + '-MediaBtn' + mediaButtonText,
            'data-video-id': mediaButton['data-video-id'],
            color: mediaButton.color
          },
          mediaButton.text
        )
      );
    }
  }]);

  return VideoImage;
}(_react2.default.Component);

exports.default = VideoImage;


VideoImage.propTypes = {
  config: _propTypes2.default.shape({
    backgroundImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired
    }).isRequired,
    type: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    mediaButton: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      text: _propTypes2.default.string,
      'data-video-id': _propTypes2.default.string.isRequired
    }).isRequired
  }),
  idx: _propTypes2.default.number,
  name: _propTypes2.default.string,
  className: _propTypes2.default.string
};

VideoImage.defaultProps = {
  config: {
    type: 'VideoImage',
    backgroundImage: {
      url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/emea/gb/en/personal/Personal_Testimonial.png'
    }
  },
  content: {
    mediaButton: {
      id: '',
      'data-video-id': 'lkz4GZgyb9o',
      text: '25 characters maximum'
    }
  },
  idx: 0,
  name: 'PanelsPanel',
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/video-image/jsx/VideoImage.js
// module id = 567
// module chunks = 4